/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Milestone_BodyInputs */

const en_us2_engagement_milestone_body = /** @type {(inputs: Engagement_Milestone_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every one of them counted. That is real consistency.`)
};

const pt_br2_engagement_milestone_body = /** @type {(inputs: Engagement_Milestone_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada um deles contou. Isso é constância de verdade.`)
};

const es_419_engagement_milestone_body = /** @type {(inputs: Engagement_Milestone_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada uno de ellos contó. Eso es constancia de verdad.`)
};

const pt_pt2_engagement_milestone_body = /** @type {(inputs: Engagement_Milestone_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada um deles contou. Isto é constância a sério.`)
};

const fr_fr2_engagement_milestone_body = /** @type {(inputs: Engagement_Milestone_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chacune d'elles a compté. Ça, c'est de la vraie régularité.`)
};

const de_de2_engagement_milestone_body = /** @type {(inputs: Engagement_Milestone_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedes einzelne hat gezählt. Das ist echte Beständigkeit.`)
};

const it_it2_engagement_milestone_body = /** @type {(inputs: Engagement_Milestone_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ognuno di loro è contato. Questa è costanza vera.`)
};

/**
* | output |
* | --- |
* | "Every one of them counted. That is real consistency." |
*
* @param {Engagement_Milestone_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_milestone_body = /** @type {((inputs?: Engagement_Milestone_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Milestone_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_milestone_body(inputs)
	if (locale === "es-419") return es_419_engagement_milestone_body(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_milestone_body(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_milestone_body(inputs)
	if (locale === "de-DE") return de_de2_engagement_milestone_body(inputs)
	if (locale === "it-IT") return it_it2_engagement_milestone_body(inputs)
	return en_us2_engagement_milestone_body(inputs)
});
export { engagement_milestone_body as "engagement.milestone_body" }